const SELECTOR = '.js-artist-list';
const TRUNCATED_CLASS = 'is-truncated';

export default function () {
    for (const artistList of document.querySelectorAll(SELECTOR)) {
        const viewAllButton = artistList.querySelector('.artist-list__view-all');

        if (!viewAllButton) {
            continue;
        }

        viewAllButton.addEventListener('click', () => {
            artistList.classList.remove(TRUNCATED_CLASS);
        });
    }
}
